import React from "react";
import {
  HashRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";

import Landing from "./Landing/Landing.component";
import Firebase from "./Auth/Firebase.component";
import Admin from "./Admin/Admin.component";

const AppRouter = ({ isAuthenticated, user, logout, handleSignIn }) => {
  return (
    <Router>
      <Switch>
        <Route path="/auth">
          {!isAuthenticated ? (
            <Firebase handleSignIn={handleSignIn} />
          ) : (
            <Redirect to="/admin" />
          )}
        </Route>
        <Route path="/admin">
          {!!isAuthenticated ? (
            <Admin logout={logout} user={user} />
          ) : (
            <Redirect to="/auth" />
          )}
        </Route>
        <Route path="/" component={Landing} />
      </Switch>
    </Router>
  );
};

export default AppRouter;

const routesToMatch = [
  "publications",
  "teaching",
  "research",
  "students",
  "home",
  "contact",
];

export { routesToMatch };
